const steps = [
  {
    number: '01',
    title: 'Start with Your Interest',
    description: "Browse our four main categories to find the lifestyle that resonates with you. Each section is packed with beginner guides, detailed how-tos, and real-world insights from experienced nomads."
  },
  {
    number: '02',
    title: 'Dive Deep',
    description: "Our articles go beyond surface-level advice. Expect practical details on costs, challenges, legal considerations, and the honest realities of alternative living — both the good and the difficult."
  },
  {
    number: '03',
    title: 'Use the Search & Glossary',
    description: "Looking for something specific? Use our search feature or explore the glossary to understand the terminology. From 'boondocking' to 'composting toilet', we've got you covered."
  }
];

export const HowToUseSection = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="font-serif text-3xl md:text-4xl font-semibold text-primary mb-4">
            How to Use This Site
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Your guide to getting the most out of Modern Nomad Living
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative text-center p-8 md:p-10 animate-fade-in"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {/* Vertical connecting line on desktop */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 right-0 w-px h-1/2 -translate-y-1/2 bg-gradient-to-b from-transparent via-border/60 to-transparent" />
              )}

              {/* Number indicator */}
              <span className="text-xs font-light tracking-[0.3em] text-muted-foreground uppercase mb-6 block">
                {step.number}
              </span>

              <h3 className="font-serif text-xl font-medium text-primary mb-3">
                {step.title}
              </h3>
              <p className="text-foreground/75 leading-relaxed font-light">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
